import menu_eva_1 from './menu_eva_1.jpg'
import menu_eva_2 from './menu_eva_2.jpg'
import menu_eva_3 from './menu_eva_3.jpg'

// 评价
const menuEva = {
    url: '/menu/eva/1000',
    res: {
        data: {
            title: {
                taste: 4.2,
                padckage: 4.7
            },
            Evaluation: [
                {
                    name: '辣舞流',
                    nameImg: menu_eva_1,
                    date: '2020-03-27',
                    time: '30',
                    content: '这个云朵（榴莲夹心？）蛋挞太好吃了！！！人间美味!',
                    menu: '香辣鸡枞菌菌菇鸡腿双层堡T,香辣鸡枞菌菌菇鸡腿卷T,榴莲之神云朵蛋挞2个T,劲爆鸡米花(大)T,波纹霸王薯条(中)T,香辣黄金鸡柳4条T'
                },
                {
                    name: 'wujiazhe2006',
                    nameImg: menu_eva_2,
                    date: '2019-12-28',
                    time: '25',
                    content: '送餐快包装好还提醒我早点下去拿#原味圣代（北美蓝莓酱）T#好吃！#原味华夫T#华夫好吃',
                    contentImg: [menu_eva_3,menu_eva_3],
                    menu: '精选超值三人餐T'
                },
                {
                    name: '辣舞流',
                    nameImg: menu_eva_1,
                    date: '2020-03-27',
                    time: '30',
                    content: '这个云朵（榴莲夹心？）蛋挞太好吃了！！！人间美味!',
                    menu: '香辣鸡枞菌菌菇鸡腿双层堡T,香辣鸡枞菌菌菇鸡腿卷T,榴莲之神云朵蛋挞2个T,劲爆鸡米花(大)T,波纹霸王薯条(中)T,香辣黄金鸡柳4条T'
                },
                {
                    name: 'wujiazhe2006',
                    nameImg: menu_eva_2,
                    date: '2019-12-28',
                    time: '25',
                    content: '送餐快包装好还提醒我早点下去拿#原味圣代（北美蓝莓酱）T#好吃！#原味华夫T#华夫好吃',
                    contentImg: [menu_eva_3,menu_eva_3],
                    menu: '精选超值三人餐T'
                },
                {
                    name: '辣舞流',
                    nameImg: menu_eva_1,
                    date: '2020-03-27',
                    time: '30',
                    content: '这个云朵（榴莲夹心？）蛋挞太好吃了！！！人间美味!',
                    menu: '香辣鸡枞菌菌菇鸡腿双层堡T,香辣鸡枞菌菌菇鸡腿卷T,榴莲之神云朵蛋挞2个T,劲爆鸡米花(大)T,波纹霸王薯条(中)T,香辣黄金鸡柳4条T'
                },
                {
                    name: 'wujiazhe2006',
                    nameImg: menu_eva_2,
                    date: '2019-12-28',
                    time: '25',
                    content: '送餐快包装好还提醒我早点下去拿#原味圣代（北美蓝莓酱）T#好吃！#原味华夫T#华夫好吃',
                    contentImg: [menu_eva_3,menu_eva_3],
                    menu: '精选超值三人餐T'
                }
            ]
        }
    }
}

export {
    menuEva
}